import React from "react";
import { COLORS } from '../../../assets/colors';
import Typography from '@mui/material/Typography';

function CategoriesHeaderUI({
    data
}) {
    return (
        <Typography variant="h2" component="h1"
            sx={{
                color: COLORS.secondary,
                fontFamily: 'Quicksand',
                fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
                fontWeight: 'bold',
                textAlign: 'center',
                paddingTop: { xs: '100px', sm: '70px', md: '80px' },
                paddingBottom: { xs: '10px', sm: '15px', md: '20px' },
                paddingLeft: '20px',
                paddingRight: '20px'
            }}
        >
            {data}
        </Typography>
    );
}

export { CategoriesHeaderUI };